<template>
  <b-dropdown
    v-if='!isMvpView && mvps && mvps.length'
    right
    no-caret
    variant='link'
    toggle-class='mvp-toggle'
    menu-class='mvp-menu'
  >
    <template #button-content>
      <b-icon icon='stars' />
      <span class='mvp-toggle-label'>Novidades em teste</span>
      <b-badge pill class='mvp-badge'>{{ mvps.length }}</b-badge>
    </template>

    <b-dropdown-item
      v-for='mvp in mvps'
      :key='mvp._id'
      :href='mvpUrl(mvp)'
      target='_blank'
      rel='noopener noreferrer'
      @click='trackBannerClick(mvp)'
    >
      <div class='mvp-item'>
        <span class='mvp-item-title'>{{ mvp.title }}</span>
        <span class='mvp-item-cta'>Testar agora</span>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MvpAnnouncement',
  computed: {
    ...mapGetters('mvp', {
      mvps: 'getMvpsActive'
    }),
    isMvpView() {
      return this.$route.name === 'MvpView'
    }
  },
  methods: {
    ...mapActions('mvp', {
      handleGetActiveMvps: 'handleGetActiveMvps',
      handleSendMvpEvents: 'handleSendMvpEvents'
    }),
    mvpUrl(mvp) {
      return this.$router.resolve({ name: 'MvpView', params: { slug: mvp.slug } }).href
    },
    trackBannerClick(mvp) {
      this.handleSendMvpEvents({ id: mvp._id, events: [{ type: 'banner_click' }] }).catch(() => {})
    }
  },
  mounted() {
    this.handleGetActiveMvps().catch(() => {})
  }
}
</script>

<style lang='scss' scoped>
::v-deep .mvp-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #022245;
  color: #ffffff;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 0 0 0 0 rgba(203, 214, 62, 0.7);
  animation: mvp-pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);

  &:hover,
  &:focus {
    color: #ffffff;
    opacity: 0.92;
    text-decoration: none;
    animation: none;
  }
}

@keyframes mvp-pulse {
  to {
    box-shadow: 0 0 0 8px rgba(203, 214, 62, 0);
  }
}

::v-deep .mvp-toggle-label {
  line-height: 1;
}

::v-deep .mvp-badge {
  background: #CBD63E;
  color: #022245;
  font-size: 12px;
}

::v-deep .mvp-menu {
  min-width: 260px;
  padding: 6px;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(2, 34, 69, 0.12);

  .dropdown-item {
    border-radius: 6px;
    padding: 8px 10px;
    white-space: normal;

    &:hover,
    &:focus {
      background: #ECF0F3;
    }

    & + .dropdown-item {
      border-top: 1px solid #e2e6ee;
    }
  }

  .mvp-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    width: 100%;
  }

  .mvp-item-title {
    width: 100%;
    font-weight: 600;
    font-size: 14px;
    color: #022245;
    white-space: normal;
    word-break: break-word;
  }

  .mvp-item-cta {
    align-self: flex-start;
    font-weight: 700;
    font-size: 12px;
    color: #6f7a12;
    background: #CBD63E;
    border-radius: 999px;
    padding: 3px 10px;
  }
}
</style>
